export const COMPANY = {
  name: "M Brothers Cleaning Services",
  shortName: "M Brothers",
  tagline: "Reliable. Professional. Spotless.",
  area: "Greater Vancouver & Surrounding Areas",
  established: 2024,
  phone: "+1 236 994 6839",
  phoneClean: "+12369946839",
  whatsapp: "+12369946839",
  email: "info@mbroservices.ca",
  agency: "Verified Digital Solutions",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_mbrothers-vancouver/artifacts/g6hpdkyo_WhatsApp_Image_2026-04-24_at_19.34.25-removebg-preview.png",
};

export const SERVICES = [
  {
    slug: "residential",
    title: "Residential Cleaning",
    short: "Routine and detailed home cleaning that keeps your space pristine.",
    description:
      "Recurring or one-time cleaning for kitchens, bedrooms, bathrooms, and living areas — performed by trained professionals using premium, eco-friendly products.",
    image:
      "https://images.unsplash.com/photo-1758273238795-c284e5ae09b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlfGVufDB8fHx8MTc3NzExMTg5N3ww&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Weekly, bi-weekly, or monthly schedules",
      "Trained, vetted, and uniformed cleaners",
      "Eco-friendly, family-safe products",
      "Detailed kitchen & bathroom sanitation",
    ],
  },
  {
    slug: "commercial",
    title: "Commercial / Office Cleaning",
    short: "Spotless workspaces that elevate your team and impress clients.",
    description:
      "Tailored cleaning programs for offices, retail, clinics, and shared spaces. Flexible after-hours scheduling and full insurance coverage.",
    image:
      "https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    benefits: [
      "Flexible after-hours service",
      "Workstation, common-area & restroom care",
      "Disinfection of high-touch surfaces",
      "Fully insured & bondable team",
    ],
  },
  {
    slug: "deep",
    title: "Deep Cleaning",
    short: "A meticulous reset for every corner of your home or office.",
    description:
      "An intensive top-to-bottom service covering the spaces standard cleans don't reach — baseboards, vents, behind appliances, grout lines and more.",
    image:
      "https://images.unsplash.com/photo-1687840936382-7333b7d26fca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlfGVufDB8fHx8MTc3NzExMTg5N3ww&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Baseboards, vents, switches & doors",
      "Inside oven, fridge & cabinets (on request)",
      "Grout & tile detailing",
      "Ideal as a seasonal reset",
    ],
  },
  {
    slug: "move",
    title: "Move-In / Move-Out Cleaning",
    short: "Hand over (or move into) a home that feels brand new.",
    description:
      "Comprehensive cleaning aligned with landlord and realtor standards — designed to help you secure your deposit or welcome new occupants with confidence.",
    image:
      "https://images.unsplash.com/photo-1753911372198-50b1b254ad4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGVtcHR5JTIwaG91c2UlMjBtb3ZlJTIwaW58ZW58MHx8fHwxNzc3MTExODk3fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Landlord & realtor approved checklist",
      "Inside cabinets, drawers & appliances",
      "Window tracks & sill detailing",
      "Walls and baseboards spot cleaning",
    ],
  },
  {
    slug: "airbnb",
    title: "Airbnb / Short-Term Rental",
    short: "Hotel-grade turnovers that protect your 5-star reviews.",
    description:
      "Reliable, photo-ready turnovers between guests with linen handling, restocking, and a final walk-through. Built for hosts who care about ratings.",
    image:
      "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlfGVufDB8fHx8MTc3NzExMTg5N3ww&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Same-day turnovers available",
      "Linen wash, change & restock",
      "Amenities & supply replenishment",
      "Photo report on completion (on request)",
    ],
  },
  {
    slug: "post-construction",
    title: "Post-Construction Cleaning",
    short: "Dust-free, move-in ready spaces after renovation or build.",
    description:
      "Heavy-duty post-renovation cleaning — fine dust removal, debris clearance, surface polishing and detailed final touch-up for a flawless handover.",
    image:
      "https://images.pexels.com/photos/6196239/pexels-photo-6196239.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    benefits: [
      "Fine construction dust removal",
      "Window, frame & glass cleaning",
      "Floor stripping, washing & polishing",
      "Final detailing for handover",
    ],
  },
];

export const WHY_CHOOSE_US = [
  {
    title: "Professional Team",
    desc: "Experienced, vetted, and uniformed cleaners you can trust in your space.",
    icon: "Users",
  },
  {
    title: "Fast & Efficient Service",
    desc: "Quick turnaround without compromising on quality or detail.",
    icon: "Zap",
  },
  {
    title: "Eco-Friendly Products",
    desc: "Safe, non-toxic supplies — gentle on your home, family, and the planet.",
    icon: "Leaf",
  },
  {
    title: "Attention to Detail",
    desc: "We focus on every corner, surface and fixture — not just what's obvious.",
    icon: "Sparkles",
  },
  {
    title: "Flexible Scheduling",
    desc: "Book at your convenience — evenings, weekends, and same-week openings.",
    icon: "CalendarClock",
  },
];

export const TRUST_ITEMS = [
  { label: "Professional Team", icon: "ShieldCheck" },
  { label: "Eco-Friendly Products", icon: "Leaf" },
  { label: "Fast Service", icon: "Zap" },
  { label: "Satisfaction Focused", icon: "Heart" },
];
